module.exports = __webpack_public_path__ + "media/img/help_center/Student_Scholarship_Search_06-0f0fe3d42c9261ce02af4371157116a2.jpg";